import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header: React.FC = () => {
  const [scrolled, setScrolled]     = useState(false);
  const [mobileActive, setMobileActive] = useState(false);
  const ticking = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      if (ticking.current) return;
      ticking.current = true;
      requestAnimationFrame(() => {
        setScrolled(window.scrollY > 80);
        ticking.current = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const handleSubmit = (e: React.FormEvent) => e.preventDefault();

  return (
    <header id="xb-header-area" className="header-area header-style--one is-sticky">
      <div
        className={`xb-header xb-sticky-stt xb-header-area-sticky xb-header-fixed`}
        style={{
          background: scrolled ? "var(--color-secondary, #11121d)" : "transparent",
          boxShadow: scrolled ? "0 3px 18px rgba(6,27,92,0.15)" : "none",
          transition: "background 0.35s ease, box-shadow 0.35s ease",
          transform: "none",
          visibility: "visible",
        }}
      >
        <div className="container mxw-1650">
          <div className="header__wrap ul_li_between">

            {/* Logo */}
            <div className="xb-header-logo">
              <Link to="/" className="logo1" onClick={handleClick}>
                <h2 style={{ margin: 0, fontWeight: 800, color: "white", fontSize: "1.8rem", letterSpacing: "-1px" }}>
                  Etern<span style={{ color: "var(--color-primary, #00D9F5)" }}>flow</span>
                </h2>
              </Link>
            </div>

            {/* Desktop nav */}
            <div className="main-menu__wrap navbar navbar-expand-lg p-0">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li><a href="#home"><span>Home</span></a></li>
                  <li><a href="#about"><span>About Us</span></a></li>
                  <li><a href="#services"><span>Services</span></a></li>
                  <li><a href="#contact"><span>Contact Us</span></a></li>
                </ul>
              </nav>
            </div>

            {/* CTA button */}
            <div className="header-btn">
              <a href="#contact" className="thm-btn">Start Automating</a>
            </div>

            {/* Mobile toggle */}
            <div className="header-bar-mobile side-menu d-lg-none">
              <button className="xb-nav-mobile" onClick={() => setMobileActive(!mobileActive)}>
                <i className="far fa-bars"></i>
              </button>
            </div>
          </div>

          {/* Mobile menu drawer */}
          <div className="xb-header-wrap">
            <div className={`xb-header-menu ${mobileActive ? "active" : ""}`}>
              <div className="xb-header-menu-scroll">
                <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => setMobileActive(false)} />
                <div className="xb-logo-mobile xb-hide-xl">
                  <Link to="/" rel="home">
                    <h2 style={{ margin: 0, fontWeight: 800, color: "white", fontSize: "1.5rem" }}>
                      Etern<span style={{ color: "var(--color-primary, #00D9F5)" }}>flow</span>
                    </h2>
                  </Link>
                </div>
                <div className="xb-header-mobile-search xb-hide-xl">
                  <form role="search" onSubmit={handleSubmit}>
                    <input type="text" placeholder="Search..." name="s" className="search-field" />
                    <button className="search-submit" type="submit">
                      <i className="far fa-search"></i>
                    </button>
                  </form>
                </div>
                <nav className="xb-header-nav">
                  <MobileMenu />
                </nav>
              </div>
            </div>
            <div className="xb-header-menu-backdrop" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
